const REQUIREMENTS = Object.freeze({
  REQUIRED: "required",
  DISABLED: "disabled",
  OPTIONAL: "optional",
});

export default REQUIREMENTS;
